import usePageUITrailResults from '@alltrails/maps/hooks/usePageUITrailResults';
import TrailResultsMapComponents from '@/components/TrailResultsMapComponents/TrailResultsMapComponents';
import useAskResponse from '@/hooks/useAskResponse';

/**
 * What the map draws while Ask AllTrails is showing, in place of the page's own map components.
 */
const AskMapComponents = () => {
  const { page } = useAskResponse();

  usePageUITrailResults(page);

  return <TrailResultsMapComponents />;
};

export default AskMapComponents;
